import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { SessionService } from '../session/session.service';

@Injectable()
export class UserService {
  private userInfo = new Subject<object>();
  private url = new Subject<string>();
  private companysAvailable: Array<Object> = [];
  private logOnData: Object = {
    cnpj: '',
    word: ''
  };

  constructor(public sessionService: SessionService) {
    const data = this.sessionService.getSession();
    if (data) {
      this.userInfo.next({ ...data });
    }
  }

  sendInfo(valorRecebido: any) {
    return new Promise((resolve, reject) => {
      this.userInfo.next({ ...valorRecebido });
      this.sessionService.setSession({ ...valorRecebido })
      resolve();
    })
    
  }

  addData(valor: any) {
    const data = this.sessionService.getSession();
    const updatedObject = Object.assign(data, valor);
    return this.sendInfo(updatedObject);
  }

  updateDataWithPhoto(image: any) {
    const data = this.sessionService.getSession();
    data['usuario'].imagem = image;
    this.sendInfo(data);
  }

  getUserData() {
    return this.sessionService.getSession();
  }

  getInfo(): Observable<any> {
    return this.userInfo.asObservable();
  }

  refreshUrl(url) {
    this.url.next(url);
  }

  getCurrentUrl(): Observable<any> {
    return this.url.asObservable();
  }

  setCompanysAvailable(companys: Array<Object>): void {
    this.companysAvailable = companys;
  }

  getCompanysAvailable(): Array<Object> {
    return this.companysAvailable;
  }

  setLogOnData(cpnj: string, pass: string): void {
    this.logOnData['cnpj'] = cpnj;
    this.logOnData['word'] = pass;
  }
  getLogOnData(): Object {
    return this.logOnData;
  }
}
